import { render, staticRenderFns } from "./PendingDocs.vue?vue&type=template&id=ca3527ec"
import script from "./PendingDocs.vue?vue&type=script&lang=js"
export * from "./PendingDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca3527ec')) {
      api.createRecord('ca3527ec', component.options)
    } else {
      api.reload('ca3527ec', component.options)
    }
    module.hot.accept("./PendingDocs.vue?vue&type=template&id=ca3527ec", function () {
      api.rerender('ca3527ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/PendingDocs.vue"
export default component.exports